import { Menu } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import React, { useMemo } from 'react';
import { useAuth } from '../../context/AuthContext';
import { isSuperAdmin } from '../../utils/permissions';

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const page = useMemo(() => {
    const currentPage = pathname.replace("/", "");
    console.log("Current pathname:", pathname);
    console.log("Current page:", currentPage);
    return currentPage;
  }, [pathname]);

  const menuItems = useMemo(() => {
    const dashboard = [
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        key={0}
      >
        <path
          d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z"
          fill={color}
        ></path>
        <path
          d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z"
          fill={color}
        ></path>
        <path
          d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z"
          fill={color}
        ></path>
      </svg>
    ];

    const users = [
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        key={0}
      >
        <path
          d="M9 2C8.44772 2 8 2.44772 8 3C8 3.55228 8.44772 4 9 4H11C11.5523 4 12 3.55228 12 3C12 2.44772 11.5523 2 11 2H9Z"
          fill={color}
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 5C4 3.89543 4.89543 3 6 3C6 4.65685 7.34315 6 9 6H11C12.6569 6 14 4.65685 14 3C15.1046 3 16 3.89543 16 5V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V5ZM7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H7.01C7.56228 11 8.01 10.5523 8.01 10C8.01 9.44772 7.56228 9 7.01 9H7ZM10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H10ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H7.01C7.56228 15 8.01 14.5523 8.01 14C8.01 13.4477 7.56228 13 7.01 13H7ZM10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H10Z"
          fill={color}
        ></path>
      </svg>
    ];

    const currencies = [
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        key={0}
      >
        <path
          d="M4 4C2.89543 4 2 4.89543 2 6V7H18V6C18 4.89543 17.1046 4 16 4H4Z"
          fill={color}
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 9H2V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V9ZM4 13C4 12.4477 4.44772 12 5 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5C4.44772 14 4 13.5523 4 13ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9Z"
          fill={color}
        ></path>
      </svg>
    ];

    const exchangeRate = [
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        key={0}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 6C3 4.34315 4.34315 3 6 3H16C16.3788 3 16.725 3.214 16.8944 3.55279C17.0638 3.89157 17.0273 4.29698 16.8 4.6L14.25 8L16.8 11.4C17.0273 11.703 17.0638 12.1084 16.8944 12.4472C16.725 12.786 16.3788 13 16 13H6C5.44772 13 5 13.4477 5 14V17C5 17.5523 4.55228 18 4 18C3.44772 18 3 17.5523 3 17V6Z"
          fill={color}
        ></path>
      </svg>
    ];

    const cards = [
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        key={0}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 6C2 4.89543 2.89543 4 4 4H16C17.1046 4 18 4.89543 18 6V14C18 15.1046 17.1046 16 16 16H4C2.89543 16 2 15.1046 2 14V6ZM4 6H16V8H4V6ZM4 10V14H16V10H4Z"
          fill={color}
        />
      </svg>
    ];

    const profile = [
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        key={0}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
          fill={color}
        ></path>
      </svg>
    ];

    const adminManagement = [
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        key={0}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 2C7.55228 2 8 2.44772 8 3V4H12V3C12 2.44772 12.4477 2 13 2C13.5523 2 14 2.44772 14 3V4H15C16.1046 4 17 4.89543 17 6V16C17 17.1046 16.1046 18 15 18H5C3.89543 18 3 17.1046 3 16V6C3 4.89543 3.89543 4 5 4H6V3C6 2.44772 6.44772 2 7 2ZM6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H6ZM6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13H14C14.5523 13 15 12.5523 15 12C15 11.4477 14.5523 11 14 11H6ZM6 15C5.44772 15 5 15.4477 5 16C5 16.5523 5.44772 17 6 17H14C14.5523 17 15 16.5523 15 16C15 15.4477 14.5523 15 14 15H6Z"
          fill={color}
        />
      </svg>
    ];

    const fxSpread = [
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        key={0}
      >
        <path
          d="M12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8Z"
          fill={color}
        />
        <path
          d="M16 16C16 17.1046 15.1046 18 14 18H2C0.895431 18 0 17.1046 0 16V14C0 12.8954 0.895431 12 2 12H14C15.1046 12 16 12.8954 16 14V16Z"
          fill={color}
        />
        <path
          d="M20 6C20 7.10457 19.1046 8 18 8H6C4.89543 8 4 7.10457 4 6V4C4 2.89543 4.89543 2 6 2H18C19.1046 2 20 2.89543 20 4V6Z"
          fill={color}
        />
      </svg>
    ];

    const treasuryAccounts = [
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        key={0}
      >
        <path
          d="M4 4C4 2.89543 4.89543 2 6 2H14C15.1046 2 16 2.89543 16 4V6C16 7.10457 15.1046 8 14 8H6C4.89543 8 4 7.10457 4 6V4Z"
          fill={color}
        />
        <path
          d="M4 10C4 8.89543 4.89543 8 6 8H14C15.1046 8 16 8.89543 16 10V12C16 13.1046 15.1046 14 14 14H6C4.89543 14 4 13.1046 4 12V10Z"
          fill={color}
        />
        <path
          d="M4 16C4 14.8954 4.89543 14 6 14H14C15.1046 14 16 14.8954 16 16V18C16 19.1046 15.1046 20 14 20H6C4.89543 20 4 19.1046 4 18V16Z"
          fill={color}
        />
      </svg>
    ];

    const offlineCollections = [
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        key={0}
      >
        <path
          d="M2 4C2 2.89543 2.89543 2 4 2H16C17.1046 2 18 2.89543 18 4V6C18 7.10457 17.1046 8 16 8H4C2.89543 8 2 7.10457 2 6V4Z"
          fill={color}
        />
        <path
          d="M2 10C2 8.89543 2.89543 8 4 8H16C17.1046 8 18 8.89543 18 10V12C18 13.1046 17.1046 14 16 14H4C2.89543 14 2 13.1046 2 12V10Z"
          fill={color}
        />
        <path
          d="M2 16C2 14.8954 2.89543 14 4 14H16C17.1046 14 18 14.8954 18 16V18C18 19.1046 17.1046 20 16 20H4C2.89543 20 2 19.1046 2 18V16Z"
          fill={color}
        />
      </svg>
    ];



    const items = [
      {
        key: '1',
        label: 'Dashboard',
        icon: dashboard,
        path: '/dashboard'
      },
      {
        key: '2',
        label: 'Cards',
        icon: cards,
        path: '/cards'
      },
      {
        key: '3',
        label: 'Customers',
        icon: users,
        path: '/users'
      },
      {
        key: '4',
        label: 'Currencies',
        icon: currencies,
        path: '/currencies'
      },
      {
        key: '5',
        label: 'Exchange Rate',
        icon: exchangeRate,
        path: '/exchange-rate'
      },
      {
        key: '6',
        label: 'FX Spread',
        icon: fxSpread,
        path: '/fx-spread'
      },
      {
        key: '7',
        label: 'Bank Accounts',
        icon: treasuryAccounts,
        path: '/bank-accounts'
      },
      {
        key: '8',
        label: 'Offline Collections',
        icon: offlineCollections,
        path: '/offline-collections'
      },
      {
        key: '9',
        label: 'Profile',
        icon: profile,
        path: '/profile'
      }
    ];

    items.splice(6, 0, {
      key: '7-a',
      label: 'Audit Logs',
      icon: users,
      path: '/audit-logs'
    });

    // Add Admin Management for Super Admins
    if (isSuperAdmin(user)) {
      items.push({
        key: '11',
        label: 'Admin Management',
        icon: adminManagement,
        path: '/admin-management'
      });
    }

    return items;
  }, [color, user?.role]);

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div className="brand">
        <img src={logo} alt="" />
        <span>Admin Portal</span>
      </div>
      <hr />
      <Menu 
        theme="light" 
        mode="inline"
        selectedKeys={[page]}
        style={{
          padding: '16px 0',
          flex: '0 1 auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px'
        }}
      >
        {menuItems.map(item => (
          <Menu.Item key={item.key} style={{ marginTop: item.key === '1' ? 0 : 8 }}>
            <NavLink to={item.path}>
              <span
                className="icon"
                style={{
                  background: page === item.path.replace('/', '') ? color : '',
                }}
              >
                {item.icon}
              </span>
              <span className="label">{item.label}</span>
            </NavLink>
          </Menu.Item>
        ))}
      </Menu>

      <div
        style={{
          padding: '24px 16px',
          borderTop: '1px solid rgba(0, 0, 0, 0.06)',
          marginTop: 'auto',
          textAlign: 'center',
          backgroundColor: '#fff'
        }}
      >
        <div style={{ marginBottom: '8px' }}>
          <a 
            href="/arriva" 
            style={{ 
              color: '#8c8c8c', 
              fontSize: '12px',
              marginRight: '8px'
            }}
          >
            Kadavra BDC
          </a>
          <span style={{ color: '#8c8c8c' }}>|</span>
          <a 
            href="/privacy" 
            style={{ 
              color: '#8c8c8c', 
              fontSize: '12px',
              margin: '0 8px'
            }}
          >
            Privacy
          </a>
          <span style={{ color: '#8c8c8c' }}>|</span>
          <a 
            href="/legal" 
            style={{ 
              color: '#8c8c8c', 
              fontSize: '12px',
              marginLeft: '8px'
            }}
          >
            Legal
          </a>
        </div>
        <div style={{ color: '#8c8c8c', fontSize: '12px', lineHeight: '1.5' }}>
          2025 Kadavra BDC
        </div>
        <div style={{ color: '#8c8c8c', fontSize: '12px' }}>
           All Rights Reserved
        </div>
      </div>
    </div>
  );
}

export default Sidenav;